import { Link } from "react-router";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";
import type { UserSubscription } from "@/lib/subscriptions";
import type { TranslationKeys } from "@/lib/i18n";

/** Page frame for the MindfulMe profile / subscription screens: back link + title. */
export function MmPage({
  backTo,
  backLabel,
  title,
  children,
}: {
  backTo?: string;
  backLabel?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className="mx-auto w-full max-w-[640px] px-4 py-8 sm:py-12">
      {backTo && backLabel && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1 text-sm text-slate-600 transition-colors hover:text-slate-900"
        >
          <ChevronLeft className="size-4" aria-hidden="true" />
          {backLabel}
        </Link>
      )}
      {title && (
        <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-[34px]">{title}</h1>
      )}
      {children}
    </div>
  );
}

export function MmCard({ className = "", children }: { className?: string; children: ReactNode }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white ${className}`}>{children}</div>;
}

/** "28 days", "month", "3 months" — used after the price slash. */
export function periodLabel(sub: UserSubscription, t: (k: TranslationKeys) => string): string {
  const unit = sub.interval;
  if (sub.intervalCount === 1) return t(`mm_${unit}` as TranslationKeys);
  return `${sub.intervalCount} ${t(`mm_${unit}s` as TranslationKeys)}`;
}
